module.exports = __webpack_public_path__ + "img/lucky.e85ccbdc.png";